import type { InvestmentsResponse } from "@paisa/types"
import { useQuery } from "@tanstack/react-query"
import { api } from "@/lib/api"

export type { InvestmentsResponse as InvestmentsData } from "@paisa/types"

export function useInvestments({ enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    enabled,
    queryKey: ["investments"],
    queryFn: () => api.get<InvestmentsResponse>("/investments"),
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}
